
// como que usaré este archivo para sacar otras fechas

function fechaMenos18() {
    var hoy = new Date()
    var anio = hoy.getFullYear() - 18
    var mes = hoy.getMonth() + 1
    var dia = hoy.getDate()

    if ( mes < 10 ) {
        mes = "0"+mes
    }

    if ( dia < 10 ) {
        dia = "0"+dia
    }

    let fechaMin = [anio, mes, dia].join('-')

    return fechaMin
}

export function mesActual() {
    var n = new Date();

    var mes = n.getMonth() + 1;
    var anio = n.getFullYear();
    if ( mes < 10) {
        mes = "0"+mes
    }
    var max = anio + "-" + mes
    return max
}

export function yearActual() {
    var n = new Date();
    return n.getFullYear();
}

export default fechaMenos18
